import {
  findById,
  findByTag,
  findFormElementFromFormComponent,
} from '../../common/utils/page_utils';

export const getPageComponentElement = (pageComponents, bindComponentId) => {
  let options = [];
  if (pageComponents.length > 0) {
    let selectedComponent = {};
    pageComponents.forEach((comp) => {
      if (comp.attributes && comp.attributes['id'] === bindComponentId) {
        if (!Object.keys(selectedComponent).length) {
          selectedComponent = comp;
        }
      } else if (comp.components) {
        if (!Object.keys(selectedComponent).length) {
          selectedComponent = findById(bindComponentId, comp);
        }
      }
    });
    const formInnerElements =
      Object.keys(selectedComponent).length > 0
        ? findFormElementFromFormComponent(selectedComponent)
        : [];
    console.log(`*** component's inner elems:`, formInnerElements);
    options = formInnerElements.map((comp) => {
      return { value: comp.attributes['name'], label: comp.attributes['name'] };
    });
  }
  return options;
};

export const pageElementOptionsForResetPassword = (state) => {
  let options = [];
  let pageElement =
    state.pageContent && Object.keys(state.pageContent).length > 0 ? state.pageContent : null;

  const pageComponents = pageElement ? JSON.parse(pageElement['nocode-components']) : [];
  let filteredComponent = [];
  pageComponents.length > 0
    ? pageComponents.forEach((comp) => {
        if (comp.tagName === 'form' || comp.tagName === 'link') {
          filteredComponent.push(comp);
        } else {
          filteredComponent = filteredComponent.concat(findByTag('form', comp));
          filteredComponent = filteredComponent.concat(findByTag('link', comp));
        }
      })
    : '';

  options = filteredComponent.map((comp) => {
    if (typeof comp.attributes !== 'undefined') {
      return { value: comp.attributes['id'], label: comp.type };
    }
  });

  let componentOptions = [];
  options.forEach((option) => {
    if (typeof option !== 'undefined') {
      componentOptions.push(option);
    }
  });
  return componentOptions;
};

export const getPageComponentElementWithCollectionFieldValue = (
  state,
  pageComponentId,
  collectionFields,
) => {
  let options = [];
  console.log('state test:>> ', state);
  let pageElement = state.pageContent ? state.pageContent : {};
  const pageComponents =
    Object.keys(pageElement).length > 0 ? JSON.parse(pageElement['nocode-components']) : [];
  console.log('pageComponents test :>> ', pageComponents);
  if (!pageComponents || pageComponents.length === 0) {
    return options;
  }

  console.log('bindComponentId test :>> ', pageComponentId);
  if (pageComponents.length > 0) {
    let selectedComponent = getPageComponentById(pageComponents, pageComponentId);
    const formInnerElements =
      Object.keys(selectedComponent).length > 0
        ? findFormElementFromFormComponent(selectedComponent)
        : [];
    console.log('formInnerElements test', formInnerElements);
    options = formInnerElements.map((comp) => {
      const fieldName = comp.attributes['name'];
      const fieldOfAttribute = collectionFields.find((e) => e.fieldName === fieldName);
      return { value: JSON.stringify(fieldOfAttribute), label: fieldName };
    });
  }
  console.log('options test :>> ', options);
  return options;
};

const getPageComponentById = (pageComponents, pageComponentId) => {
  let selectedComponent = {};
  for (const comp of pageComponents) {
    console.log('comp.attributes test', comp.attributes);
    if (comp.attributes && comp.attributes['id'] === pageComponentId) {
      selectedComponent = comp;
      console.log('Attr Id selectedComponent :>> ', selectedComponent);
    }
    if (!Object.keys(selectedComponent).length && comp.components) {
      selectedComponent = findById(pageComponentId, comp);
      console.log('Comp selectedComponent :>> ', selectedComponent);
    }
    console.log('selectedComponent test:>> ', selectedComponent);
  }
  return selectedComponent;
};
